import React, { Component, Fragment } from 'react';
import LandingHeader from '../components/landing/LandingHeader';
import LandingFooter from '../components/landing/LandingFooter';
import GetStarted from '../components/landing/GetStarted';
import Heading from '../components/global/Heading';
import ContentSection from '../components/landing/ContentSection';
import '../static/SecondaryPages.css';

const Title = props => (
	<Fragment>
		<h1 className='mb-10 mt-20'>{props.children}</h1>
	</Fragment>
);

const Paragraph = props => (
	<p className='mb-10'>{props.children}</p>
);

class Cookies extends Component {
	render() {
		return(
			<Fragment>
				<LandingHeader history={this.props.history} />
				<Heading title='Cookies' />
				
				<ContentSection style={{ background: 'white' }} noAnimate={true} addedSectionClass="p-0 t-a-c-padding">
					<div className='tos-content-container'>
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
							<Title>Information about our use of cookies</Title>
						</div>

						<Paragraph>
							Our sites use cookies to distinguish you from other users of our site, and estimates visits and click throughs for specific campaigns. This helps us to provide you with a good experience when you browse our site and also allows us to improve our site. These cookies expire when your browsing session ends.  By continuing to browse the site, you are agreeing to our use of cookies. 
						</Paragraph>

						<Paragraph>
							A cookie is a small file of letters and numbers that we store on your browser or the hard drive of your computer if you agree. Cookies contain information that is transferred to your computer&apos;s hard drive.
						</Paragraph>

						<Paragraph>
							For detailed information on the cookies we use and the purposes for which we use them see our table below:
						</Paragraph>

						<Paragraph>
							We use the following types of cookies:
						</Paragraph>

						<Paragraph>
							Strictly necessary cookies. These are cookies that are required for the operation of our site. They include, for example, cookies that enable you to log into secure areas of our site, use a shopping cart or make use of e-billing services.
						</Paragraph>

						<Paragraph>
							Analytical/performance cookies. They allow us to recognize and count the number of visitors and to see how visitors move around our site when they are using it. This helps us to improve the way our site works, for example, by ensuring that users are finding what they are looking for easily.
						</Paragraph>

						<Paragraph>
							Functionality cookies. These are used to recognize you when you return to our site. This enables us to personalize our content for you, greet you by name and remember your preferences (for example, your choice of language or region).
						</Paragraph>

						<Paragraph>
							You can find more information about the individual cookies we use and the purposes for which we use them in the table below:
						</Paragraph>


						<table>
							<thead>
								<tr>
									<th>Cookie</th>
									<th>Name</th>
									<th>Purpose</th>
									<th>More </th>
								</tr>
							</thead>

							<tbody>
								<tr>
									<td>GoogleAnalytics/tagmanager</td>
									<td>ga(&apos;create&apos;, &apos;UA-41735386-1&apos;, &apos;pilotlyProd&apos;);</td>
									<td style={{ fontSize: '10px'}}>Google Analytics is Google’s analytics tool that helps website and app owners to understand how their visitors engage with their properties. It may use a set of cookies to collect information and report website usage statistics without personally identifying individual visitors to Google. The main cookie used by Google Analytics is the ‘__ga’ cookie.</td>
									<td><a href='https://policies.google.com/technologies/types'>https://policies.google.com/technologies/types</a></td>
								</tr>
								<tr>
									<td>Linkedin – Targeting cookie</td>
									<td>linkedin_data_partner_id = 349074</td>
									<td style={{ fontSize: '10px'}}>We have added a LinkedIn pixel to our website to collect general information such as industry and company size of visitors of our web property. LinkedIn does not share personal data with any third-party advertisers or ad networks for their advertising except for: (i) hashed or device identifiers (to the extent they are personal data in some countries); (ii) with your separate permission (e.g., lead generation form) or (iii) data already visible to any users of the Services (e.g. profile).</td>
									<td>
										<a href='https://www.linkedin.com/legal/privacy-policy'>https://www.linkedin.com/legal/privacy-policy</a>
										<p>and</p>
										<a href='https://www.linkedin.com/legal/cookie-policy'>https://www.linkedin.com/legal/cookie-policy</a>
									</td>
								</tr>
							</tbody>
						</table>

						<Paragraph>
							Please note that third parties (including, for example, advertising networks and providers of external services like web traffic analysis services) may also use cookies, over which we have no control. These cookies are likely to be analytical/performance cookies or targeting cookies.
						</Paragraph>

						<Paragraph>
							You block cookies by activating the setting on your browser that allows you to refuse the setting of all or some cookies. However, if you use your browser settings to block all cookies (including essential cookies) you may not be able to access all or parts of our site.
						</Paragraph>

						<Paragraph>
							Except for essential cookies, all cookies will expire after the period specified via the links set out in the ‘more information’ column in the table above.
						</Paragraph>


					</div>
				</ContentSection>

				<GetStarted />
				<LandingFooter />
			</Fragment>
		);
	}
}

export default Cookies;


// WEBPACK FOOTER //
// ./src/pages/Cookies.js